import { useMemo } from "react";

/**
 * @deprecated This hook is deprecated and should not be used in new code.
 * This was overengineered - static data like Yes/No options doesn't need a hook or memoization.
 * Use the YesNoOptions constant from '../constants/options/YesNoOptions.js' instead 
 * for better performance and simpler usage.
 */
export default function useYesNoOptions() {
    const yesNoOptions = useMemo(() => [
        { value: "true", label: "Yes", trackingId: "Yes" },
        { value: "false", label: "No", trackingId: "No" }
    ], []);

    return yesNoOptions;
}